module.exports = __webpack_public_path__ + "img/northernArc.1da7be70.png";